import React, { useEffect, useRef, useState } from 'react';
import Pagination from '../Header/Pagination';
import contractServices from '../Contracts/contractServices';
import Modal from 'react-responsive-modal';
import DeleteDialogueBox from '../Common/deleteDialogue';
import WizardServices from 'components/wizard/WizardServices';

export function ContractReleases(contractReleases: any) {

    console.log(contractReleases)

    let [activeTab, setactiveTab] = useState(0);
    let [PartyTotalRow, setPartyTotalRow] = useState(0);
    let [systemRegions, setsystemRegions] = useState<any>([]);
    let [PartyReleaseListing, setPartyReleaseListing] = useState<any>([]);
    let [editAssociateRelease, seteditAssociateRelease] = useState<any>([]);
    let [AssociateReleaseTotalRow, setAssociateReleaseTotalRow] = useState(0);
    let [fieldsInvalid, setFieldsInvalid] = useState(false);
    let [AssociateReleaseListing, setAssociateReleaseListing] = useState<any>([]);
    let [PartyReleaseListingTemp, setPartyReleaseListingTemp] = useState<any>([]);
    let [AssociateReleaseListingTemp, setAssociateReleaseListingTemp] = useState<any>([]);

    var associatePayload = { pageNumber: 1, pageSize: 10 }
    var partyRelease = { pageNumber: 1, pageSize: 10 }


    useEffect(() => {
        console.log(contractReleases.data.contractRefNum)

        if (contractReleases.data.contractRefNum) {
            apiCall();

            WizardServices.contractssystemsystemRegions(contractReleases.data.contractRefNum).then((value: any) => {
                setsystemRegions(value)
            })
        }

        setdeleteJob(false);
        setdeleteJobData({})
    }, []);

    const closecontractReleases = () => { contractReleases.closecontractReleases() }

    const apiCall = () => {
        editAssociateRelease.contractRefNum = contractReleases.data.contractRefNum;
        editAssociateRelease.manualSplit = contractReleases.data.contractRefNum;
        editAssociateRelease.contractSplit = contractReleases.data.contractRefNum;
        seteditAssociateRelease({ ...editAssociateRelease })

        if (activeTab === 0) {
            contractServices.getMainContractsListing(contractReleases.data.contractRefNum).then((value: any) => {
                var obj = value.slice((associatePayload.pageNumber - 1) * associatePayload.pageSize, (associatePayload.pageSize * associatePayload.pageNumber));
                setAssociateReleaseListing(obj);
                setAssociateReleaseListingTemp(value);
                setAssociateReleaseTotalRow(value ? value.length : 0)
            })
        }

        if (activeTab === 1) {
            contractServices.getThirdPartyContractsListing(contractReleases.data.contractRefNum).then((value: any) => {

                var obj = value.slice((partyRelease.pageNumber - 1) * partyRelease.pageSize, (partyRelease.pageSize * partyRelease.pageNumber));

                setPartyReleaseListing(obj);
                setPartyReleaseListingTemp(value);
                setPartyTotalRow(value ? value.length : 0)
            })
        }
    }

    const getMainContractsListing = (n: any) => {
        associatePayload.pageNumber = n.pageNumber;
        associatePayload.pageSize = n.pageSize;

        var obj = AssociateReleaseListingTemp.slice((associatePayload.pageNumber - 1) * associatePayload.pageSize, (associatePayload.pageSize * associatePayload.pageNumber));
        setAssociateReleaseListing(obj);
    }

    const getThirdPartyContractsListing = (n: any) => {
        associatePayload.pageNumber = n.pageNumber;
        associatePayload.pageSize = n.pageSize;

        var obj = AssociateReleaseListingTemp.slice((associatePayload.pageNumber - 1) * associatePayload.pageSize, (associatePayload.pageSize * associatePayload.pageNumber));
        setAssociateReleaseListing(obj);
    }

    const saveReleaseSplits = () => {

        console.log(editAssociateRelease)
        if (filedValidation()) {
            if (activeTab === 0) {
                WizardServices.mainContractsSave(contractReleases.code.contractRefNum, editAssociateRelease).then((value: any) => {
                    apiCall();
                })
            }

            if (activeTab === 1) {
                WizardServices.getThirdPartyContractSave(contractReleases.code.contractRefNum, editAssociateRelease).then((value: any) => {
                    apiCall();
                })
            }

        }
    }

    const filedValidation = () => {
        var status = false;
        const calcSplit: any = document.getElementById("calcSplit");
        const incTracks: any = document.getElementById("incTracks");
        const relTracks: any = document.getElementById("relTracks");
        const RegionCode: any = document.getElementById("RegionCode");
        const contTracks: any = document.getElementById("contTracks");
        const catLogNumber: any = document.getElementById("CatLogNumber");
        const automaticUpd: any = document.getElementById("automaticUpd");
        const percentageOwned: any = document.getElementById("percentageOwned");

        console.log(editAssociateRelease)
        if (!editAssociateRelease?.catLogNumber) {
            catLogNumber.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.calcSplit) {
            calcSplit.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.relTracks && activeTab === 0) {
            relTracks.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.incTracks && activeTab === 0) {
            incTracks.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.contTracks && activeTab === 0) {
            contTracks.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.automaticUpd && activeTab === 0) {
            automaticUpd.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.regionCode && activeTab === 0) {
            RegionCode.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (!editAssociateRelease?.percentageOwned && activeTab === 1) {
            percentageOwned.style.border = "1px solid #e50e0e";
            setFieldsInvalid(true)
        }

        if (editAssociateRelease?.catLogNumber && editAssociateRelease?.calcSplit && editAssociateRelease?.relTracks && editAssociateRelease?.incTracks && editAssociateRelease?.contTracks
            && editAssociateRelease?.automaticUpd && editAssociateRelease?.regionCode && activeTab === 0) {
            status = true;
            setFieldsInvalid(false);
        } else if (editAssociateRelease?.catLogNumber && editAssociateRelease?.calcSplit && editAssociateRelease?.percentageOwned && activeTab === 1) {
            status = true;
            setFieldsInvalid(false);
        }

        setTimeout(function () {
            if (activeTab === 0) {
                incTracks.style.border = "1px solid #dedede";
                relTracks.style.border = "1px solid #dedede";
                RegionCode.style.border = "1px solid #dedede";
                contTracks.style.border = "1px solid #dedede";
                automaticUpd.style.border = "1px solid #dedede";
            }

            if (activeTab === 1) {
                percentageOwned.style.border = "1px solid #dedede";
            }

            calcSplit.style.border = "1px solid #dedede";
            catLogNumber.style.border = "1px solid #dedede";
            setFieldsInvalid(false)
        }, 2000);

        return status;
    }

    const onReleaseSplitClear = () => {
        editAssociateRelease = {}
        seteditAssociateRelease({ ...editAssociateRelease })
    }

    const [deleteJob, setdeleteJob] = useState(false);
    const [deleteJobData, setdeleteJobData] = useState<any>([]);

    /*
{AssociatesaveAlert && <div className="alert alert-success">Contract Associated to Release  Split Release has been saved successfully </div>}
{AssociatedeleteAlert && <div className="alert alert-success">Contract Associated to Release  Split Release has been deleted successfully </div>}
{PartysaveAlert && <div className="alert alert-success">3rd Party Contracts  has been saved successfully</div>}
{PartydeleteAlert && <div className="alert alert-success">3rd Party Contracts  has been deleted successfully</div>}
    */
    const seleteDeleteData = (e: any) => {
        console.log(e)
        setdeleteJob(true);
        setdeleteJobData(e)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {

            if (activeTab === 0) {
                WizardServices.mainContractsDelete(contractReleases.code.contractRefNum, deleteJobData.splitId).then(() => {
                    setdeleteJob(true);
                    apiCall();
                })
            }

            if (activeTab === 1) {
                WizardServices.getThirdPartyContractDelete(contractReleases.code.contractRefNum, deleteJobData.relSubId).then(() => {
                    setdeleteJob(true);
                    apiCall();
                })
            }

            setTimeout(function () {
                setdeleteJob(false);
            }, 3000);
        }

        setdeleteJobData({});
    };

    return (<>

        <Modal open={contractReleases.opencontractReleases} onClose={() => closecontractReleases()} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-11 paddingCenterBox bgTransparent' }} >
            <div className='ws-12 landing'>
                <ul className="nav nav-tabs">
                    <li className={activeTab === 0 ? "active" : ""} onClick={() => { setactiveTab(0); apiCall() }}> <a>Contract Associated to Release</a> </li>
                    <li className={activeTab === 1 ? "active" : ""} onClick={() => { setactiveTab(1); apiCall() }}> <a>3rd Party Contracts</a> </li>
                </ul>
                {fieldsInvalid && <div className="alert alert-danger">There was a problem submitting your request, one or more fields are missing or incorrect. </div>}

                {activeTab === 0 && <div className="ws-12 mt">
                    <div className="ws-12 box">
                        <div className="box-header well"><h2>Add/Edit a release</h2></div>

                        <div className="box-content">

                            <div className="ws-12">
                                <div className="ws-4">
                                    <input type="hidden" data-ng-model="release.splitId" />
                                    <input type="hidden" data-ng-model="release.automaticUpd" />

                                    <div className="form-format">
                                        <label className="control-label">Catalog*</label>

                                        <div className="label-entries">
                                            <input value={editAssociateRelease.catLogNumber ?? ""} type="text" onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, catLogNumber: e.target.value })} id="CatLogNumber" placeholder="Enter catalog" required />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Contract</label>

                                        <div className="label-entries">
                                            <input value={editAssociateRelease.contractRefNum ?? ""} readOnly type="text" id="ContractRefNum" />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label" >Region Code*</label>
                                        <div className="label-entries">
                                            <div className="alert alert-danger hide">  No region associated with current contract. Please associate a region with the current contract first. </div>
                                            <select className="form-control" value={editAssociateRelease.regionCode ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, regionCode: e.target.value })}
                                                id="RegionCode" name="RegionCode" required>
                                                <option value="">Choose region</option>
                                                {systemRegions?.map((values: any, index: any) => {
                                                    return (
                                                        <option value={values.groupingId} label={values.groupDesc} >{values.groupDesc}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>

                                        <div className="form-format mt">
                                            <label className="control-label w-35">Automatic Update*</label>

                                            <div className="label-entries w-60">
                                                <input type="checkbox" checked={editAssociateRelease.automaticUpd ?? false} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, automaticUpd: e.target.value })} id="automaticUpd" name="automaticUpd" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-4">

                                    <div className="form-format">
                                        <label className="control-label">Calc(d) Split*</label>

                                        <div className="label-entries">
                                            <input data-ng-model="release.calcSplit" value={editAssociateRelease.calcSplit ?? ""} className="text-right" type="number" onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, calcSplit: e.target.value })} id="calcSplit" placeholder="Enter calc(d) split" required />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Contract Split</label>

                                        <div className="label-entries">
                                            <input ng-model="release.contractSplit" value={editAssociateRelease.contractSplit ?? ""} className="text-right" type="number" min="0" onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, contractSplit: e.target.value })} name="ContractSplit" placeholder="Contract Split" disabled />

                                            <div className="alert alert-danger hide"> Contract Split should be numeric</div>
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Manual Split</label>

                                        <div className="label-entries">
                                            <input value={editAssociateRelease.manualSplit ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, manualSplit: e.target.value })} type="number" className="text-right" id="manualSplit" name="manualSplit" min="0" placeholder="Manual Split" disabled />

                                            <div className="alert alert-danger hide">  Manual Split should be numeric</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-4">

                                    <div className="form-format">
                                        <label className="control-label">Rel(s) Tracks*</label>

                                        <div className="label-entries">
                                            <input value={editAssociateRelease.relTracks ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, relTracks: e.target.value })} className="text-right" type="number" id="relTracks" name="relTracks" placeholder="Enter rel(s) tracks" required />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Inc Tracks*</label>

                                        <div className="label-entries">
                                            <input value={editAssociateRelease.incTracks ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, incTracks: e.target.value })} className="text-right" type="number" min="0" id="incTracks" name="incTracks" placeholder="Enter inc tracks" required />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Cont Tracks*</label>

                                        <div className="label-entries">
                                            <input value={editAssociateRelease.contTracks ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, contTracks: e.target.value })} className="text-right" type="number" id="contTracks" name="contTracks" placeholder="Enter cont tracks" required />
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="box-footer">

                            <button type="button" className="icon-btn delete btn-sm" onClick={onReleaseSplitClear}>  <i className="icon-refresh"></i> Reset </button>
                            <button type="button" className="icon-btn edit btn-sm" onClick={saveReleaseSplits}>  <i className="icon-save"></i> Save  </button>
                        </div>
                    </div>

                    <div className="box">
                        <div className="box-header well"> <h2>{AssociateReleaseTotalRow} record(s) found</h2> </div>

                        <div className="box-content">
                            {(AssociateReleaseTotalRow > 0) && <div className="form-horizontal row-fluid">
                                <div className="form-format ws-6">

                                    <div className="label-entries">
                                        <input type="text" placeholder="Search" data-ng-model="filter.release" id="release" />
                                    </div>
                                </div>
                            </div>}
                            {(AssociateReleaseTotalRow === 0) && <div className="alert alert-info"> No records found </div>}
                            {(AssociateReleaseTotalRow > 0) && <div className="table-responsive">
                                <table className="table MTable" data-ng-show="filteredReleaseSplits.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Catalog</th>
                                            <th>Contract</th>
                                            <th>Title</th>
                                            <th>Calc(d) Split</th>
                                            <th>Rel(s) Tracks</th>
                                            <th>Inc Tracks</th>
                                            <th>Cont Tracks</th>
                                            <th>Contract Split</th>
                                            <th>Manual Split</th>
                                            <th>Region Code</th>
                                            <th>Automatic Update</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AssociateReleaseListing.map((value: any) => {
                                            return (
                                                <tr>
                                                    <td>{value.catLogNumber}</td>
                                                    <td>{value.contractRefNum}</td>
                                                    <td>{value.releaseTitle}</td>
                                                    <td className="text-right">{value.calcSplit}</td>
                                                    <td className="text-right">{value.relTracks}</td>
                                                    <td className="text-right">{value.incTracks}</td>
                                                    <td className="text-right">{value.contTracks}</td>
                                                    <td className="text-right">{value.contractSplit}</td>
                                                    <td className="text-right">{value.manualSplit}</td>
                                                    <td>{value.regionCode}</td>
                                                    <td>
                                                        <span ng-if="release.automaticUpd === true" >{value.automaticUpd}</span>

                                                    </td>
                                                    <td >
                                                        <div className='width90'>
                                                            <a onClick={() => seteditAssociateRelease(value)} className="icon-btn edit"  ><i className="icon-edit"></i></a>
                                                            <a onClick={() => seleteDeleteData(value)} className="icon-btn delete"><i className="icon-trashcan"></i> </a>
                                                        </div>

                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>}

                            <div className="clearfix ptl">
                                {
                                    (() => {
                                        if (AssociateReleaseTotalRow && AssociateReleaseTotalRow > 10) {
                                            return <Pagination onChange={getMainContractsListing} totalRows={AssociateReleaseTotalRow} />
                                        }

                                    })()
                                }

                            </div>
                        </div>
                    </div>
                </div>}

                {activeTab === 1 && <div className="ws-12 mt">
                    <div className="ws-12 box">
                        <div className="box-header well"> <h2>Add/Edit a release </h2> </div>

                        <div className="ws-12 pm">

                            <div className="ws-4">
                                <div className="form-format">
                                    <label className="control-label">Catalog *</label>

                                    <div className="label-entries">
                                        <input value={editAssociateRelease.catLogNumber ?? ""} type="text" id="catLogNumber" onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, catLogNumber: e.target.value })} name="catLogNumber" placeholder="Enter catalog" required />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Contract</label>

                                    <div className="label-entries">
                                        <input value={editAssociateRelease.contractRefNum ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, contractRefNum: e.target.value })} type="text" id="contractRefNum" readOnly name="contractRefNum" placeholder="Contract" required />
                                    </div>
                                </div>
                                <div className="form-format">
                                    <label className="control-label w-35">Automatic Update</label>

                                    <div className="label-entries w-60">
                                        <input type="checkbox" checked={editAssociateRelease.automaticUpd ?? false} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, automaticUpd: e.target.value })} id="automaticUpdTP" name="automaticUpd" data-ng-change="setTPSplitsValue()" />
                                    </div>
                                </div>
                            </div>

                            <div className="ws-4">
                                <div className="form-format">
                                    <label className="control-label">Calc(d) Split *</label>
                                    <div className="label-entries">
                                        <input value={editAssociateRelease.calcSplit ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, calcSplit: e.target.value })} name="calcSplit" type="number" className="text-right" placeholder="Enter calc(d) split" required />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Contract Split</label>
                                    <div className="label-entries">
                                        <input value={editAssociateRelease.contractSplit ?? ""} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, contractSplit: e.target.value })} className="text-right" type="number" min="0" id="contractSplit" name="contractSplit" placeholder="Contract split"
                                            disabled={editAssociateRelease.contractSplit} />

                                        <div className="alert alert-danger hide" > Contract Split should be numeric </div>

                                    </div>
                                </div>
                            </div>

                            <div className="ws-4">

                                <div className="form-format">
                                    <label className="control-label">Manual Split</label>

                                    <div className="label-entries">
                                        <input value={editAssociateRelease.manualSplit} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, manualSplit: e.target.value })} className="text-right" type="number" min="0" id="manualSplit" name="manualSplit" placeholder="Manual Split" disabled={editAssociateRelease.manualSplit} />

                                        <div className="alert alert-danger hide"> Manual Split should be numeric </div>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Percentage Owned*</label>

                                    <div className="label-entries">
                                        <input value={editAssociateRelease.percentageOwned} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, percentageOwned: e.target.value })} type="number" className="text-right" id="percentageOwned" name="percentageOwned" placeholder="Percentage owned" required />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <div className="label-entries">
                                        <input value={editAssociateRelease.automaticUpd} onChange={(e: any) => seteditAssociateRelease({ editAssociateRelease, automaticUpd: e.target.value })} ng-model="TPRelease.automaticUpd" type="hidden" name="automaticUpd" />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <div className="label-entries">
                                        <input ng-model="TPRelease.relSubId" type="hidden" name="relSubId" />
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="box-footer">
                            <button className="icon-btn delete" onClick={onReleaseSplitClear}><i className="icon-refresh"></i> Reset  </button>
                            <button className="icon-btn edit  " onClick={saveReleaseSplits}>  <i className="icon-save"></i> Save   </button>
                        </div>
                    </div>

                    <div className="box">
                        <div className="box-header well"> <h2> {PartyTotalRow} record(s) found</h2> </div>


                        <div className="box-content">
                            {(PartyTotalRow > 0) && <div className="form-horizontal row-fluid">
                                <div className="form-format ws-6">

                                    <div className="label-entries">
                                        <input type="text" placeholder="Search" data-ng-model="filter.TPRelease" id="release" />
                                    </div>
                                </div>
                            </div>}

                            {(PartyTotalRow === 0) && <div className="alert alert-info"> No records found </div>}

                            {(PartyTotalRow > 0) && <div className="table-responsive">
                                <table className="newTable" data-ng-show="filteredTPReleaseSplits.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Catalog</th>
                                            <th>Contract</th>
                                            <th>Calc(d) Split</th>
                                            <th>Contract Split</th>
                                            <th>Manual Split</th>
                                            <th>Percentage Owned</th>
                                            <th>Automatic Update</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {PartyReleaseListing.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td>{values.catLogNumber}</td>
                                                    <td>{values.contractRefNum}</td>
                                                    <td className="text-right">{values.calcSplit}</td>
                                                    <td className="text-right">{values.contractSplit}</td>
                                                    <td className="text-right">{values.manualSplit}</td>
                                                    <td className="text-right">{values.percentageOwned}</td>
                                                    <td>
                                                        {values.automaticUpd && <span>Yes</span>}
                                                        {!values.automaticUpd && <span>No</span>}
                                                    </td>

                                                    <td >
                                                        <a onClick={() => seteditAssociateRelease(values)} className="icon-btn edit"> <i className="icon-edit"></i>  </a>
                                                        <a onClick={() => seleteDeleteData(values)} className="icon-btn delete"> <i className="icon-trashcan"></i>  </a>
                                                    </td>
                                                </tr>

                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>}

                            <div className="clearfix">
                                {
                                    (() => {
                                        if (PartyTotalRow && PartyTotalRow > 10) {
                                            return <Pagination onChange={getThirdPartyContractsListing} totalRows={PartyTotalRow} />
                                        }

                                    })()
                                }
                            </div>

                        </div>
                    </div>

                </div>}

                <div className="box-footer">
                    <button className="icon-btn delete btn-sm" data-ng-click="closeRelPopup()"><i className="icon-close"></i> Close
                    </button>
                </div>

                {
                    (() => {

                        if (deleteJob) {
                            return <DeleteDialogueBox param={true} message={"delete Release Sub Split with contract " + deleteJobData.contractRefNum + "and catalog" + deleteJobData.catLogNumber + ""} onChange={Confirmation} />
                        }
                    })()
                }
            </div>
        </Modal>

    </>)
}